import { render } from "./MapAreaSelect.vue?vue&type=template&id=e08ca724&ts=true"
import script from "./MapAreaSelect.vue?vue&type=script&lang=ts"
export * from "./MapAreaSelect.vue?vue&type=script&lang=ts"

import "./MapAreaSelect.vue?vue&type=style&index=0&id=e08ca724&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__